import {
  Avatar,
  Box,
  Button,
  Chip,
  Grid2,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { StyledMenu } from "Components/Common/StyledMenu";
import UserImage from "Assets/Images/Creator.svg";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  paddingTop: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

const LeaderBoardTable = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [users, setUsers] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState(
    "problem_solving_percentage"
  );

  const { Users, Translation } = useSelector((state) => ({
    Users: state.LeaderBoard.users,
    Translation: state.Translation.translation?.LeaderBoard || {},
  }));

  let sortList = useMemo(() => ({
    problem_solving_percentage: Translation?.ProblemSolvingPercentage,
    reputation_points: Translation?.ReputationPoints,
    problem_solving_streaks: Translation?.ProblemSolvingStreak
  }), [Translation]);

  const columns = useMemo(() => {
    return [
      { label: Translation?.Name, accessor: "FullName" },
      { label: Translation?.Rank, accessor: "Rank" },
      {
        accessor: "ProblemSolved",
        label: Translation?.ProblemSolvedPercentage,
      },
      {
        accessor: "Marks",
        label: Translation?.ReputationPoints,
      },
      {
        accessor: "current_problem_solving_streaks",
        label: Translation?.CurrentProblemSolvingStreaks
      },
      {
        accessor: "GraduationYear",
        label: Translation?.GraduationYear
      },
    ];
  }, [Translation])

  const handleUsersFilter = (key) => {
    let sortedUsers = JSON.parse(JSON.stringify(Users));
    if (key === "problem_solving_percentage") {
      sortedUsers.sort((a, b) => b.ProblemSolved - a.ProblemSolved);

    } else if (key === "reputation_points") {
      sortedUsers.sort((a, b) => b.Marks - a.Marks);

    } else if (key === "problem_solving_streaks") {

    } else {

    }

    setUsers(sortedUsers);
    setSelectedFilter(key);
    setAnchorEl(null);
  }

  useEffect(() => {
    setUsers(Users);

  }, [Users])

  return (
    <Grid2 sx={styles}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography
          display={"flex"}
          alignItems={"center"}
          gap="8px"
          variant="subtitle"
          fontWeight={500}
        >
          <PrimaryIcon icon={AlertIcon} />
          {Translation?.LeaderBoardNote}
        </Typography>
        <Button
          endIcon={<KeyboardArrowDownIcon />}
          variant="outlined"
          color="primary"
          outlinedFilled
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          {Translation?.SortBy}: &nbsp;
          <Typography fontWeight={500} variant="subtitle">
            {" "}
            {sortList[selectedFilter]}
          </Typography>
        </Button>
        <StyledMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <Typography
            variant="subtitle"
            display={"flex"}
            p={"6px 16px"}
            fontWeight={500}
            color="secondary.light"
          >
            {Translation?.SortRankBy}:
          </Typography>
          {Object.entries(sortList)?.map(([key, value], i) => {
            return (
              <MenuItem
                onClick={() => handleUsersFilter(key)}
                key={i}
              >
                {value}
              </MenuItem>
            );
          })}
        </StyledMenu>
      </Box>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column, i) => (
                <TableCell key={i}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(users) && users.map((item, i) => {
              return (
                <TableRow hover key={`bodyRow${i}`}>
                  {columns.map((column, i) => {
                    return (
                      <TableCell key={`bodyCol${i}`}>
                        {column?.accessor == "FullName" ? (
                          <Box display={"flex"} alignItems={"center"} gap="8px">
                            <Avatar
                              sx={{ width: 32, height: 32 }}
                              src={item.ProfilePictureUrl}
                              alt="User Icon"
                            />
                            <Typography fontWeight={500}>
                              {item[column?.accessor]}
                            </Typography>
                          </Box>
                        ) : column?.accessor == "Rank" ? (
                          <Chip
                            label={<Typography fontWeight={500}>{item[column?.accessor]}</Typography>}
                            rectangle
                            variant="outlined"
                            // color="success"
                            color={item[column?.accessor] > 3 ? "primary": "success"}
                          />
                        ) : (
                          <Typography>{item[column?.accessor]}</Typography>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid2>
  );
};

export default LeaderBoardTable;
